<template>
    
</template>

<script>
    export default {
        mounted() {
            if (!this.$authService.isLoggedIn()) {
                this.$authService.login()
            }
            else {
                this.$router.push('/')
            }
        }
    }
</script>